import React, { useState, useEffect } from 'react';
import '../App.css';

const CountdownTimer = () => {
    const [timeLeft, setTimeLeft] = useState('');

    useEffect(() => {
        const calculateTimeLeft = () => {
            const now = new Date();
            // Target is next 22:00
            let target = new Date(now);
            target.setHours(22, 0, 0, 0);

            // If it's already past 22:00, target is tomorrow 22:00
            if (now > target) {
                target.setDate(target.getDate() + 1);
            }

            const diff = target - now;

            const hours = Math.floor((diff / (1000 * 60 * 60)) % 24);
            const minutes = Math.floor((diff / (1000 * 60)) % 60);
            const seconds = Math.floor((diff / 1000) % 60);

            return `${hours.toString().padStart(2, '0')}:${minutes.toString().padStart(2, '0')}:${seconds.toString().padStart(2, '0')}`;
        };

        const timer = setInterval(() => {
            setTimeLeft(calculateTimeLeft());
        }, 1000);

        setTimeLeft(calculateTimeLeft());

        return () => clearInterval(timer);
    }, []);

    return (
        <div className="countdown-timer">
            <span className="label">🏆 Kazananın Belirlenmesine:</span>
            <span className="time">{timeLeft}</span>
        </div>
    );
};

export default CountdownTimer;
